import getConfig from 'next/config';

import { gijpTheme } from './fregijp/theme';
import { manualTheme } from './fremanual/theme';
import { fseDefaultTheme } from './fse/theme';
import { fseintTheme } from './fseint/theme';
import { freiGijpRichtTextValues } from './fregijp/lang/freiGijpRichtTextValues';
import { freManualRichtTextValues } from './fremanual/lang/freManualRichtTextValues';
import { fseRichtTextValues } from './fse/lang/fseRichtTextValues';
import { fseIntRichTextValues } from './fseint/lang/fseIntRichTextValues';

const { clientId } = getConfig().publicRuntimeConfig;

/**
 * @typedef {Object} ReturnProps
 * @property {Theme} theme - The theme object for the current client.
 * @property {Record<LanguagesLong, Record<import("~/config/useGetRichtTextValues").TranslationHelpers,string>>} translationHelpers
 */

/**
 * Get the configuration for the current client.
 * This function returns a configuration object based on the CLIENT_ID environment variable.
 *
 * @returns {ReturnProps} The configuration object for the current client.
 */
export const getClientConfig = () => {
  switch (clientId) {
    case 'fregijp':
      return {
        theme: gijpTheme,
        translationHelpers: freiGijpRichtTextValues,
      };
    case 'fremanual':
      return {
        theme: manualTheme,
        translationHelpers: freManualRichtTextValues,
      };
    case 'fse':
      return {
        theme: fseDefaultTheme,
        translationHelpers: fseRichtTextValues,
      };
    case 'fseint':
      return {
        theme: fseintTheme,
        translationHelpers: fseIntRichTextValues,
      };
    default:
      throw new Error(`Unknown CLIENT_ID: ${clientId}`);
  }
};
